export default {
  // 新增油罐费用
  insertYgCost: '/ygsjzs/ygCost/insertYgCost',
  updateYgCost: '/ygsjzs/ygCost/updateYgCost',
  // 查询油罐费用详情
  selectYgCostById: '/ygsjzs/ygCost/selectYgCostById',
  // 分页查询油罐费用列表
  selectYgCostByPage: '/ygsjzs/ygCost/selectYgCostByPage'
}
